var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/trailer';
import http from 'app/services/http';
const defaultSort = config.trailerColumns[0];
const initialState = {
    items: [],
    checkedItems: [],
    selectedItem: null,
    sortSelectedItem: { name: defaultSort.name, order: defaultSort.order },
    searchValue: '',
};
export const trailerReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    switch (action.type) {
        case 'TRAILER_SET_ITEMS': {
            const { items } = (_a = action.payload) !== null && _a !== void 0 ? _a : {};
            return Object.assign(Object.assign({}, state), { items: items !== null && items !== void 0 ? items : state.items });
        }
        case 'TRAILER_SET_SELECTED_ITEM': {
            const { data } = (_b = action.payload) !== null && _b !== void 0 ? _b : {};
            return Object.assign(Object.assign({}, state), { selectedItem: (_c = data) !== null && _c !== void 0 ? _c : null });
        }
        case 'TRAILER_SET_SEARCH_VALUE': {
            const { value } = (_d = action.payload) !== null && _d !== void 0 ? _d : {};
            return Object.assign(Object.assign({}, state), { searchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'TRAILER_SET_SORT_SELECTED_ITEM': {
            const data = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                } });
        }
        case 'TRAILER_ADD_ITEM': {
            const data = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { items: [...state.items, data] });
        }
        case 'TRAILER_UPDATE_ITEM': {
            const data = (_g = action.payload) === null || _g === void 0 ? void 0 : _g.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { selectedItem: data, items: state.items.map((item) => (state.selectedItem && item.id === state.selectedItem.id ? data : item)) });
        }
        case 'TRAILER_DELETE_ITEM': {
            const { id } = (_h = action.payload) !== null && _h !== void 0 ? _h : {};
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.id !== id), selectedItem: null });
        }
        default:
            return state;
    }
};
export function trailerLoad() {
    return function trailerLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/trailer');
            return dispatch(actions.setItems(data));
        });
    };
}
export function trailerFormLoad() {
    return __awaiter(this, void 0, void 0, function* () {
        return http
            .get('/trailer')
            .then((response) => response.data)
            .catch(() => undefined);
    });
}
export function trailerCreate(params) {
    return function trailerCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/trailer', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function trailerUpdate(id, params) {
    return function trailerUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/trailer/${id}`, params);
            return dispatch(actions.updateItem(data));
        });
    };
}
export function trailerDelete(id) {
    return function trailerDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/trailer/${id}`);
            return dispatch(actions.deleteItem(id));
        });
    };
}
export default trailerReducer;
